<template>
  <div class="main-body">
    <div class="header">
      用药列表
    </div>
    <div class="out">

      <div class="search2">

          <div style="float:right">
            <el-input placeholder="请输入老人姓名" v-model="elderlyName" clearable style="margin:0 10px;width:200px"></el-input>
            <el-select
                v-model="status"
                style="margin:0 10px;width:200px"
                placeholder="请选择状态">
              <el-option
                  v-for="(item,i) in statusValue"
                  :key="i"
                  :label="item"
                  :value="i">
              </el-option>
            </el-select>
            <el-button size="mini" style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
          </div>


        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" v-loading="loading"
                highlight-current-row @row-click="rowClick" :height="th"
                border>

        <el-table-column type="expand" v-if="tableData.length">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="药品：">
                <el-tag v-for="(value,i) in props.row.medicationItemList"
                        :key="i" style="margin-right: 5px;">{{value.name}}</el-tag>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>

        <el-table-column prop="elderlyName" label="老人姓名"></el-table-column>

        <el-table-column prop="name" label="用药组名称"></el-table-column>

        <el-table-column prop="status" :formatter="statusTitle" label="状态"></el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "Page",
  data(){
    return{
      loading:false,
      menuButtonList:null,
      disabledAdd:false,
      disabledEdit:true,
      showModalAdd:false,
      showModalEdit:false,
      showModalGetElderly:false,
      tableData:[],
      row:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,
      status:0,
      elderlyName:'',
      statusValue:['药品组状态','正常','禁用'],
      th:0,
      options:[]
    }
  },
  components:{

  },
  created(){
    this.init();

    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{
    rowClick(row){
      this.row=row;
      this.disabledEdit =false;
    },
    init(){
      this.getList();
    },
    openAdd(data){
      this.closeAdd()
      this.$refs.myAdd.init(data);
    },
    getList(){
      this.loading = true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"MedicationGroup/GovPage",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          elderlyName:this.elderlyName,
          status:this.status-1,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {
        this.loading = false;
        this.disabledEdit = true;
        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    handleGetElderly(index, row) {
      this.$refs.myGetElderly.init(row);
      this.showModalGetElderly = !this.showModalGetElderly;
    },
    handleEdit() {
      this.$refs.myEdit.init(this.row);
      this.showModalEdit = !this.showModalEdit;
    },
    toggleModalAdd:function(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myGetElderly.init();
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },
    toggleModalGetElderly:function(){
      this.showModalGetElderly = !this.showModalGetElderly;
    },
    closeGetElderly:function(){
      this.showModalGetElderly = !this.showModalGetElderly;
    },

    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.init();
    },
    formatTime:function (row, column, cellValue) {
      return timefilters(cellValue);
    },
    statusTitle(row){
      if(row.status == 0){
        return "正常";
      }
      if(row.status == 1){
        return "禁用";
      }
      return "其它";
    },

  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-table__body tr.current-row>td {
  background-color: #409EFF;
  color:#fff;
}

</style>
